import { gql, MutationHookOptions, useMutation } from "@apollo/client";

export const USER_LOGOUT = gql`
  mutation userLogout {
    userLogout {
      authenticatable {
        id
      }
    }
  }
`;

export default (
  options?: MutationHookOptions<null, null>
) => {
  return useMutation<null, null>(
    USER_LOGOUT,
    options
  );
};
